export const PAYMENT_TYPE_OPTIONS = [
  { value: 'GUARANTEE', label: 'Guarantee' },
  { value: 'DOWN_PAYMENT', label: 'Down Payment' },
  { value: 'PAYMENT', label: 'Payment' },
  { value: 'EXTRA', label: 'Extra' },
  { value: 'FULL_PAYMENT', label: 'Full Payment' },
  { value: 'BALANCE', label: 'Balance' },
  { value: 'OTHER', label: 'Other' },
];

export const PAYMENT_TYPE_LABELS = PAYMENT_TYPE_OPTIONS.reduce((labels, { value, label }) => {
  labels[value] = label;
  return labels;
}, {});
